import axios from 'axios';
import Config from 'Config';

type GeocoderResults = google.maps.GeocoderResult;

const extractCityStateCountry = (result: GeocoderResults): { city: string; state: string; countryCode: string } => {
  let city = '';
  let state = '';
  let countryCode = '';

  for (const comp of result.address_components) {
    if (!city && comp.types.includes('locality')) {
      city = comp.long_name;
    }
    if (!state && comp.types.includes('administrative_area_level_1')) {
      state = comp.short_name;
    }
    if (!countryCode && comp.types.includes('country')) {
      countryCode = comp.short_name;
    }
    if (city && state && countryCode) break;
  }

  return { city, state, countryCode };
};

export const getClosestCityLatLong = async (lat: number, long: number) => {
  try {
    const { data } = await axios.get<{ results: GeocoderResults[] }>(
      'https://maps.googleapis.com/maps/api/geocode/json',
      {
        params: {
          key: Config.googleMapsApiKey,
          latlng: `${lat}, ${long}`,
          sensor: false,
          result_type: 'political',
        },
      },
    );
    if (data.results.length > 0) {
      const preferredAddress = data.results.find((r) => r.types.includes('locality')) || data.results[0];
      const { city, state, countryCode } = extractCityStateCountry(preferredAddress);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { lat: latitude, lng: longitude } = data.results[0].geometry.location as any;

      return {
        city,
        state,
        countryCode,
        lat: latitude as number,
        long: longitude as number,
      };
    }
  } catch (error) {
    console.error('Error fetching closest city and coordinates:', error);
    return {
      city: '',
      state: '',
      countryCode: '',
      lat: '',
      long: '',
    };
  }
};
